import { graphql, useStaticQuery } from "gatsby"
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next"

import InnerWrapper from "components/InnerWrapper"
import BottomCallout from "components/sectionTemplates/BottomCallout"
import Callout from "components/TextElements/Callout"
import text from "styles/text"
import { checkedLocaleLink } from "utils/routes"
import useMedia from "utils/useMedia"

export default function Bottom() {
  const { t } = useTranslation()
  const { language } = useI18next()
  const titleWidth = useMedia("1027px", "42.771vw", "68.066vw", "89.333vw")
  const textWidth = useMedia("368px", "22.169vw", "45.41vw", "89.333vw")
  const titleSize = useMedia(text.h3, text.h3, text.h3, text.h1Mobile)
  const kickerInfo = useMedia(
    t("FIND OUT WHAT'S POSSIBLE WITH GALILEO"),
    t("FIND OUT WHAT'S POSSIBLE WITH GALILEO"),
    t("FIND OUT WHAT'S POSSIBLE WITH GALILEO"),
    t("FIND OUT WHAT'S POSSIBLE")
  )

  const images: Queries.HomeBottomQuery = useStaticQuery(graphql`
    query HomeBottom {
      desktop: file(relativePath: { eq: "homepage/BottomCTAD.webp" }) {
        ...LocalImageQuery
      }
      tablet: file(relativePath: { eq: "homepage/BottomCTAT.webp" }) {
        ...LocalImageQuery
      }

      mobile: file(relativePath: { eq: "homepage/BottomCTAM.webp" }) {
        ...LocalImageQuery
      }
    }
  `)

  const desktop = images.desktop?.childImageSharp?.gatsbyImageData
  const tablet = images.tablet?.childImageSharp?.gatsbyImageData
  const mobile = images.mobile?.childImageSharp?.gatsbyImageData

  const img = useMedia(desktop, tablet, mobile, mobile)
  const sectionHeight = useMedia("1017px", "56.446vw", "122.461vw", "234.4vw")

  return (
    <BottomCallout
      sectionHeight={sectionHeight}
      img={img}
      objectFit="initial"
      imgHeight={sectionHeight}
      imgWidth="100vw"
    >
      <InnerWrapper setWidth={useMedia("880px", "53.012vw", "", "")}>
        <Callout
          variant="darkMode"
          kicker={{
            text: kickerInfo,
            icon: "circles",
          }}
          title={{
            content: t("Start expanding your financial frontier."),
            size: titleSize,
            width: titleWidth,
          }}
          text={{
            content: t(
              "Accelerate your path to putting best-in-class financial products and experiences in your customers’ hands."
            ),
            width: textWidth,
          }}
          buttons={[
            {
              text: t("Contact Sales") ?? "Contact Sales",
              arrow: true,
              route: checkedLocaleLink("/contact-us", language),
            },
          ]}
        />
      </InnerWrapper>
    </BottomCallout>
  )
}
